import { uploadImageUrl } from "../config/config";
import axiosInstance from "../axios/axiosTokenMiddleware";

export const testUrl = ({brand_name, model_name, part_name, color_name, no}) => {
  return `https://dev.backend.mobigarage.com/v1/mp/accounts/upload_spare_product_image?brand_name=${brand_name}&model_name=${model_name}&part_name=${part_name}&color_name=${color_name}&no=${no}`;
};

export const testUploadImageRequest = async (file, brand_name, model_name, part_name, color_name, no) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const url = testUrl(brand_name, model_name, part_name, color_name, no);
    const response = await axiosInstance.post(url, formData);

    console.log("Upload successful:", response.data);

    return response.data; // Return only the needed data
  } catch (error) {
    console.error("Error during upload:", error);
    throw new Error("File upload failed");
  }
};
